export function initPasswordToggle() {
  document.querySelectorAll('[data-password-toggle]').forEach(btn => {
    const input = btn.closest('.relative, [data-field]')?.querySelector('input[type="password"], input[type="text"]');
    if (!input) return;
    const icon = btn.querySelector('i');

    btn.addEventListener('click', () => {
      const isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';
      if (icon) {
        icon.className = isPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye';
      }
    });
  });
}
